const refundGoodsLogisticsCN = {
    title:"填写物流信息",
    returnGoods:"退货商品",
    total:"合计",
    submithint:"提交",
    returnLogisticsNumber:"物流单号",
    returnLogisticsNumberHit:"请填写物流单号",
    returnLogisticsName:"物流公司",
    returnLogisticsNameHit:"请输入物流公司",
    hit:"注：物流只收韵达或者圆通",
    returnExpressCompany: "退货快递公司",
    chooseReturnDeliveryCompany: "选择退货快递公司",
    YTO:"圆通快递",
    YunDa:"韵达快递"
}

const refundGoodsLogisticsEN = {
    title:"Fill in logistics information",
    returnGoods:"Return of the goods",
    total:"Total",
    submithint:"Submit",
    returnLogisticsNumber:"Tracking number",
    returnLogisticsNumberHit:"Delivery company",
    returnLogisticsName:"Delivery company",
    returnLogisticsNameHit:"Delivery company",
    hit:"Remark: only Yunda and Yuantong Courier are allowed",
    returnExpressCompany: "Return express company",
    chooseReturnDeliveryCompany: "Choose a return delivery company",
    YTO:"YTO",
    YunDa:"YunDa"
}

const langPackage = {
    cn: refundGoodsLogisticsCN,
    en: refundGoodsLogisticsEN
}

export {langPackage}
